import * as SettingsActionTypes from '../../types/settings';

export default function settings(state = {}, action = {}) {
    switch (action.type) {
        case SettingsActionTypes.SET_WITH_REVISIONS: {
            return {
                ...state, withRevision: action.payload };
        }

        case SettingsActionTypes.SET_WITH_PRE_REVISIONS: {
            return {
                ...state, withPreRevision: action.payload };
        }

        case SettingsActionTypes.SHOW_PDF_VIEWER: {
            return {
                ...state, showPdfViewer: action.payload };
        }

        default: {
            return state;
        }
    }
}
